import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import {useEffect, useState} from "react";
import '../public/styles/style.css';
import {Button, notification, Pagination, Spin} from "antd";
import {APIs} from "../constants/api.constants";
import {gridOption, frameworkComponents, dateFormatter, dateFilterParams} from '../constants/ag-grid.constants';
import {ApiService} from "../services/ApiService";
import EpisodeQuestionModal from "../custom-components/episode-popups/quiz";
import UploadVideo from "../custom-components/episode-popups/upload-video";
import AddEpisode from "../custom-components/episode-popups/add-episode";
import UploadProfile from "../custom-components/upload-profile";
import {AuthenticationService} from "../services/AuthenticationService";
import axios from 'axios';
import EpisodeAssessment from "../components/assessments/questions/EpisodeAssessmentModal";
import EditEpisode from '../custom-components/episode-popups/edit-episode';
import DeleteEpisode from '../custom-components/episode-popups/delete-episode';
import Search from 'antd/lib/input/Search';
import UploadSubtitle from "../custom-components/episode-popups/upload-subtitle";
import SortingTypeOption from '../custom-components/filter-and-sorting-popovers/sorting-type-option';
import { episodeSortingConstant } from '../constants/sorting.constants';


export default function Episodes() {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisibility] = useState(false);
  const [uploadVisibility, setUploadVisibility] = useState(false);
  const [data, setData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [course, setNewCourse] = useState(null);
  const [episodeNumber, setEPNumber] = useState(null);
  const [episodeName, setEPName] = useState('');
  const [description, setDesc] = useState('');
  const [link, setLink] = useState('');
  const [videoFile, setVideo] = useState(null);
  const [fileName, setFileName] = useState('');
  const [thumbnail, setThumbnail] = useState(null);
  const [episodeData, setEpData] = useState({});
  const [percentage, setPercentage] = useState(0.00);
  const [quizVisibility, setQuizVisibility] = useState(false);
  const [quizEpisode, setAddingQuizEpisode] = useState(null);
  const [thumbnailPopupIsOpen, showThumbnailPopupVisibility] = useState(false);
  const [imagePopupIsOpen, setImagePopupIsOpen] = useState(false);
  const [assessmentPopupIsOpen, setAssessmentPopupIsOpen] = useState(false);
  const [assessmentId, setAssessmentId] = useState(0);
  const [imageFile, setImage] = useState(null);
  const [currentImageUrl, setImageUrl] = useState('');
  const [currentVideoUrl, setVideoUrl] = useState('');
  const [textShowing, showText] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);
  const [isOpen, toggleEdit] = useState(false);
  const [checkBox1, setCheckBox1] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalEpisode, setTotalEpisode] = useState(null);
  const [filterValue, setFilterValue] = useState("");
  const [sort, setSort] = useState("idAscending")
  const [subtitleUploadVisibility, setSubtitleUploadVisibility] = useState(false);
  const [subtitleFile, setSubtitleFile] = useState(null);
  const [currentSubtitleName, setCurrentSubtitleName] = useState('');

  const columnDefs = [
    {
      headerName: 'Episode ID',
      field: "lms_id",
      minWidth: 150,
      editable: false,
    },
    {
      headerName: 'Course Name',
      field: "episode_name",
      minWidth: 300,
      editable: false,
      valueGetter: (param) => param.data?.course?.course_name || param.data?.course?.course_name_th || '-',
    },
    { headerName: 'Episode Name', field: "episode_name", minWidth: 300, editable: false, },
    { headerName: 'Episode Number', field: "episode_number", minWidth: 200, editable: false, },
    {
      headerName: 'Is Free Trial',
      field: "is_free_trial",
      cellRenderer: "customSwitch",
      editable: false,
      cellRendererParams: {
        param: 'is_free_trial',
        clicked: function(field) {
          field.is_free_trial = !field.is_free_trial;
          const data = { data : field };
          editEpisode(data,false);
        }
      },
      minWidth: 115,
    },
    { field: "description", minWidth: 200, editable: false },
    {
      field: "Upload Video",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: 'Upload',
        buttonClass: 'primary',
        clicked: function(field) {
          setEpData({ data: field });
          setVideoUrl(field.link_video);
          toggleVideoPopup();
        }
      },
      minWidth: 150,
    },
    {
      field: "Upload Subtitle",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: 'Upload',
        buttonClass: 'primary',
        clicked: function(field) {
          setEpData({ data: field });
          setCurrentSubtitleName(field?.subtitleName || '');
          toggleSubtitleUpload();
        }
      },
      minWidth: 150,
    },
    {
      field: "Current Image",
      editable: false,
      cellRenderer: "imageCellRenderer",
      cellRendererParams: {
        field: 'thumbnail_image',
      },
      minWidth: 150,
    },
    {
      field: "Upload Thumbnails",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: 'Upload',
        buttonClass: 'primary',
        clicked: function(field) {
          setImageUrl(field?.thumbnail_image || '');
          setEpData({ data: field });
          toggleImagePopup();
        }
      },
      minWidth: 200,
    },
    {
      headerName: 'Created Date',
      field: 'createDate',
      valueGetter: dateFormatter,
      minWidth: 200,
      editable: false,
      filter: 'agDateColumnFilter',
      filterParams: dateFilterParams,
    },
    {
      headerName: 'Updated Date',
      field: 'updateDate',
      valueGetter: dateFormatter,
      minWidth: 200,
      editable: false,
      filter: 'agDateColumnFilter',
      filterParams: dateFilterParams,
    },
    {
      field: "Edit",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "Edit",
        buttonClass: "primary",
        clicked: function (field) {
          setEpData({ data: field });
          setNewCourse(field.course.course_name);
          setEPNumber(field.episode_number);
          setEPName(field.episode_name);
          setDesc(field.description);
          setVideoUrl(field.link_video);
          toggleEditPopup();
        },
      },
      minWidth: 150,
    },
    {
      headerName: "View Assessment",
      field: "assessment",
      minWidth: 200,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "View Assessment",
        buttonClass: "primary",
        clicked: function (field) {
          setAssessmentId(field.id);
          toggleAssessmentPopup();
        },
      },
    },
    {
      headerName: "Disable",
      field: "deletedAt",
      cellRenderer: "customSwitch",
      editable: false,
      sort: 'asc',
      sortIndex: 0,
      cellRendererParams: {
        param: 'deletedAt',
        clicked: function(field) {
          field.deletedAt
              ? restoreEpisode(field)
              : deleteEpisode(field);
        }
      },
      minWidth: 120,
    },
    {
      field: "Deleted",
      editable: false,
      cellRenderer: "btnCellRenderer",
      sortIndex: 0,
      cellRendererParams: {
        buttonText: "Delete",
        buttonClass: "primary",
        clicked: function (field) {
          setEpData(field);
          setDeleteId(field.id);
          toggleDeletePopup();
        },
      },
      minWidth: 100,
    },
  ];

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  useEffect(() => {
    getEpisodes();
    getCourses();
  }, []);

  function getCourses() {
    ApiService.getRequest(APIs.courses).then(
        (res) => setCourses(res.data),
        (error) => notification['error']({message: error.message}),
    );
  }

  function getEpisodes(
      page = 1,
      limit = 100,
      sorting = "idAscending",
      filterValue
  ) {
    setLoadingRows(true);
    const param = {
      limit: limit,
      page: page,
      filterValue: filterValue,
      sorting: sorting,
    };
    ApiService.getRequest(APIs.episode + "/pagination", param).then(
        (res) => {
          setTotalEpisode(res.data.meta.totalCount);
          setData(res.data.data);
          setLoadingRows(false);
        },
        (error) => notification["error"]({message: error.message})
    );
  }

  function createEpisode() {
    setLoading(true);
    let postData = {
      "course": course,
      "episode_number": episodeNumber,
      "episode_name": episodeName,
      "description": description,
      "link_video": link
    }
    ApiService.postRequest(APIs.episode, postData).then(
        (res) => {
          setData([...data, res.data]);
          getEpisodes(page, limit, sort, filterValue);
          thumbnail ? createThumbnailForEpisode(res.data, thumbnail) : resetInputs();
        },
        (error) => {
          notification['error']({message: error.message});
        }
    );
  }

  function createThumbnailForEpisode(data, thumbnailFile) {
    if (!thumbnailFile) {
      editEpisode({
        data: {...data, thumbnail_image: ''},
      });
      return
    }
    const fd = new FormData();
    fd.append('file', thumbnailFile);
    ApiService.postRequest(APIs.courses + '/upload', fd).then(
        (res) => {
          editEpisode({
            data: {...data, thumbnail_image: res.data},
          });
          showThumbnailPopupVisibility(false);
          resetInputs();
        },
        error => notification['error']({message: error.message})
    )
  }

  function editEpisode(event, trigger_load = true) {
    const newData = {
      "episode_number": event.data.episode_number,
      "episode_name": event.data.episode_name,
      "description": event.data.description,
      "link_video": event.data.link_video,
      "is_free_trial": event.data.is_free_trial,
      "thumbnail_image": event.data.thumbnail_image || '',
    }
    ApiService.updateRequest(APIs.episode + '/' + event.data.id, newData).then(
        () => {
          resetInputs();
          if (trigger_load === true) {
            getEpisodes(page, limit, sort, filterValue);
          }
          setImagePopupIsOpen(false);
        },
        (error) => {
          getEpisodes(page, limit, sort, filterValue);
          notification['error']({message: error.message});
        }
    );
  }

  function deleteEpisode(event) {
    ApiService.deleteRequest(APIs.episode + '/' + event.id).then(
        () => getEpisodes(page, limit, sort, filterValue),
        (error) => {
          notification['error']({message: error.message});
        }
    );
  }

  function restoreEpisode(event) {
    ApiService.updateRequest(APIs.episode + '/recover/' + event.id).then(
        () => getEpisodes(page, limit, sort, filterValue),
        (error) => {
          notification['error']({message: error.message});
        }
    );
  }

  function uploadVideo(episodeData) {
    if (!videoFile) {
      setLoading(false);
      setVisibility(false);
      return;
    }
    const fd = new FormData()
    fd.append('file', videoFile)
    axios.post(`${APIs.uploadVideo}/${episodeData.data.id}`, fd, {
      headers: {
        Authorization: AuthenticationService.getHeaders(),
        "Tus-Resumable": "1.0.0"
      },
      onUploadProgress: (progressEvent) => {
        const {loaded, total} = progressEvent;
        let percentage = Math.floor((loaded * 100) / total);
        setPercentage(percentage);
      }
    }).then((res) => {
      videoDetail(episodeData)
    })
  }

  const videoDetail = (episodeData) => {
    ApiService.getRequest(APIs.episode + `/${episodeData.data.id}`).then(
        (res) => {
          editEpisode(episodeData)
        },
        (error) => notification['error']({message: error.message}),
    );
  }

  function resetInputs() {
    setEPNumber(null);
    setEPName('');
    setDesc('');
    setLink('');
    setVideo(null);
    setFileName('');
    setNewCourse(null);
    setThumbnail(null);
    setLoading(false);
    setImage(null);
    setLoading(false);
    setUploadVisibility(false);
    setVisibility(false);
    setPercentage(0.00);
    showText(false);
    setLoading(false);
    setSubtitleFile(null);
  }

  function toggleEditPopup() {
    isOpen && resetInputs();
    toggleEdit(!isOpen);
  }

  // add episode
  const toggleAddEpisode = () => {
    resetInputs();
    setVisibility(!visible);
  };

  // upload video
  const toggleVideoPopup = () => {
    resetInputs();
    setUploadVisibility(!uploadVisibility);
  }

  const uploadNewVideo = () => {
    setLoading(true);
    // uploadVideo(episodeData);
  }

  const toggleAssessmentPopup = () => {
    setAssessmentPopupIsOpen(!assessmentPopupIsOpen);
  };

  const toggleSubtitleUpload = () => {
    resetInputs();
    setSubtitleUploadVisibility(!subtitleUploadVisibility);
  }

  // upload thumbnail
  function toggleImagePopup() {
    !imagePopupIsOpen && resetInputs();
    setImagePopupIsOpen(!imagePopupIsOpen);
  }

  function uploadNewImage() {
    setLoading(true);
    createThumbnailForEpisode(episodeData.data, imageFile);
  }

  // Quiz
  const toggleQuizPopup = () => {
    resetInputs();
    setQuizVisibility(!quizVisibility);
  }

  function thumbnailClick() {
    document.getElementById('thumbnail').click();
  }

  function handleClick() {
    setVideo(null);
    document.getElementById('fileUpload').click();
  }

  function submitEdit() {
    setLoading(true);
    setLoadingRows(true);
    const newData = {
      episode_id: episodeData.data.id,
      episode_number: episodeNumber,
      episode_name: episodeName,
      description: description,
      course: course,
      link_video: currentVideoUrl,
    };
    if (typeof course === "string") {
      delete newData.course;
    }
    ApiService.postRequest(APIs.episode + `/edit-episode`, newData).then(
        (res) => {
          getEpisodes(page, limit, sort, filterValue)
          setLoading(false);
          setLoadingRows(false);
          toggleEditPopup();
        },
        (error) => {
          notification["error"]({message: error.message});
          setLoading(false);
          setLoadingRows(false);
          toggleEditPopup();
        }
    );
  }

  function resetDeleteInput() {
    setEpData({});
    setDeleteId(null);
    setCheckBox1(false);
    setCheckBox2(false);
  }

  function toggleDeletePopup() {
    deleteVisible && resetDeleteInput();
    setDeleteVisible(!deleteVisible)
  }

  function hardDelete() {
    if (checkBox1 !== true || checkBox2 !== true) {
      return notification["error"]({
        message: "please check all the checkbox to confirm deletion",
      });
    }
    setLoading(true);
    setLoadingRows(true);
    ApiService.deleteRequest(
        APIs.episode + "/hard-delete/" + deleteId
    ).then(() => {
      setLoading(false);
      toggleDeletePopup();
      getEpisodes(page, limit, sort, filterValue);
    }),
        (error) => {
          notification["error"]({message: error.message});
          setLoading(false);
          toggleDeletePopup();
          setLoadingRows(false);
        };
  }

  function UploadSubtitles() {
    if (!subtitleFile) {
      return notification["error"]({ message: "Please Select Subtitle File" });
    }
    const url = `${APIs.uploadSubtitle}/${episodeData.data.id}`;
    ApiService.uploadFile(url, subtitleFile).then(
        () => {
          toggleSubtitleUpload();
        },
        (error) => {
          notification["error"]({ message: error.message });
        }
    )
  }

  const uploadVideoProps = { uploadVisibility, toggleVideoPopup, textShowing, videoFile, setVideo,
    percentage, setPercentage, loading, setLoading, handleClick, currentVideoUrl,
    episodeData};

  const uploadSubtitleProps = { subtitleUploadVisibility, toggleSubtitleUpload, subtitleFile, setSubtitleFile,
    loading, UploadSubtitles, currentSubtitleName }

  const addEpisodeProps = { toggleAddEpisode, createEpisode, visible, loading, course, setNewCourse,
    episodeNumber, setEPNumber, episodeName, setEPName, description, courses,
    setDesc, link, setLink, thumbnail, setThumbnail, thumbnailClick, handleClick}

  const addProfileProps = { setImageUrl, imagePopupIsOpen, uploadNewImage, toggleImagePopup, setImage, imageFile,
    loading, currentImageUrl };

  const episodeAssessmentProps = {assessmentId, assessmentPopupIsOpen, toggleAssessmentPopup,courses};

  const editEpisodeProps = {isOpen, loading, toggleEditPopup, setEPNumber, episodeNumber, course, setNewCourse, courses,
    episodeName, setEPName, description, setDesc, currentVideoUrl, setVideoUrl, submitEdit}

  const deleteEpisodeProps = {loading, deleteVisible, toggleDeletePopup, checkBox1, setCheckBox1, checkBox2, setCheckBox2,
    episodeData,hardDelete}

  return <>
    <div className={"w-100percent row no-gutters"}>
      <div className="col-sm-5 pr-1 pb-3">
        <Search placeholder="input search text"
                allowClear
                className={`w-100percent`}
                onSearch={(value) => {
                  setFilterValue(value);
                  getEpisodes(page, limit, sort, value);
                }}
                prefix
                enterButton>
        </Search>
      </div>
      <div className="col-sm-5 pb-3">
      <SortingTypeOption
            types={episodeSortingConstant}
            valueType={sort}
            changeFunction={(value) => {
              setSort(value);
              getEpisodes(page, limit, value, filterValue);
            }}
          />
      </div>
      <div className="col-sm-2 text-right pb-3">
        <Button type='primary'
                onClick={toggleAddEpisode}>
          Add New Row
        </Button>
      </div>
    </div>

    <AddEpisode props={addEpisodeProps}/>
    <UploadVideo props={uploadVideoProps}/>
    <UploadProfile props={addProfileProps}/>
    <EpisodeAssessment props={episodeAssessmentProps}/>
    <EpisodeQuestionModal quizVisibility={quizVisibility}
                          quizEpisode={quizEpisode}
                          closeQuiz={toggleQuizPopup}/>

    <EditEpisode props={editEpisodeProps}/>
    <DeleteEpisode props={deleteEpisodeProps}/>
    <UploadSubtitle props={uploadSubtitleProps} />

    <Spin tip='Loading....' size='small' spinning={loadingRows}>
      <div className="example-wrapper h-minus-180">
        <div className="ag-theme-alpine  w-100percent h-100percent">
          <AgGridReact rowData={data}
                       columnDefs={columnDefs}
                       defaultColDef={gridOption}
                       enableCellTextSelection={true}
                       animateRows={true}
                       onCellValueChanged={editEpisode}
                       frameworkComponents={frameworkComponents}
                       getRowNodeId={function (data) {
                         return data.id;
                       }} />
        </div>
        <div className="d-flex w-100percent justify-content-end pt-2">
          <Pagination
              onChange={(page, limit) => {
                setPage(page);
                setLimit(limit);
                getEpisodes(page, limit, sort, filterValue);
              }}
              showQuickJumper
              defaultCurrent={1}
              total={totalEpisode}
              pageSize={limit}
              pageSizeOptions={[50, 100, 500, 1000]}
          />
        </div>
      </div>
    </Spin>
  </>;
}
